'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../node_modules/@material-ui/core/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  carouselItem: {
    padding: 8,
    boxSizing: 'border-box'
  }
};

var CarouselItem = function CarouselItem(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      style = _ref.style,
      props = objectWithoutProperties(_ref, ["classes", "children", "style"]);

  return React__default["default"].createElement("div", {
    className: classes.carouselItem,
    style: style
  }, React.cloneElement(children, props));
};

var CarouselItem$1 = withStyles(styles)(CarouselItem);

module.exports = CarouselItem$1;
